import React, { useEffect, useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { validationDocumentDelivery } from "../../components/validations/validationDocumentDelivery";
import { validationPPT } from "../../components/validations/validationPPT";
import ModalReportProblem from "../../Modals/ModalTermAndConditions/ModalReportProblem";
import DataForm from "../../components/form/DataForm";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import { useToastInfo } from "../../Hooks/useToastInfo";
import { GET_STATE_BY_COUNTRY } from "../../Graphql/queries/queryGetStateByCountry";
import { useToastError } from "../../Hooks/useToastError";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { CHECK_DOCUMENT } from "../../Graphql/queries/queryCheckDocument";
import { MUTATION_CREATE_BIOMETRIC_REGISTRATION } from "../../Graphql/mutations/mutationCreateRegisterBiometric";
import { RoutesNames } from "../../components/utils/routes";
import { Variables } from "../../styles/Variables";
import IconBack from "../../components/Icons/IconBack";
import { AppForm } from "../../forms/AppForm";
import { AppInput } from "../../forms/AppInput";
import { AppSubmit } from "../../forms/AppSubmit";
import ModalTermsConditions from "../../Modals/ModalTermAndConditions/ModalTermsConditions";

import {
  AnimationLoading,
  BackButton,
  ContainerBackAndInfo,
  ContainerFormVerify,
  ContainerGlobal,
  ContainerInputs1,
  // ContainerInputs2,
  ContainerReportProblem,
  ContainerRight,
  ContainerTransparent,
  ContainerUp,
  ContainerVerify,
  ContentForms,
  Header,
  HeaderForm,
  ImgIcon,
  ImgLeft,
  Info,
  Text,
  TextBack,
  TextBold,
  TextBoldRed,
  TextInformative,
  TextVerification,
  Title,
  TopText,
} from "../../styles/PageStyles/LegalAndDocumental/stylesDocumentsDelivery";
import useScreenSize from "../../Hooks/useScreenSize";

export default function DocumentsDelivery() {
  const navigate = useNavigate();
  /* eslint-disable */
  const SITE_KEY = process.env.REACT_APP_SITE;
  const TERMS_HABEAS_DATA = process.env.REACT_APP_TERMS_HABEAS_DATA;
  /* eslint-enable */
  const { width } = useScreenSize();
  const [modalVisible, setModalVisible] = useState(false);
  const [documentNumber, setDocumentNumber] = useState("");
  const [openReport, setOpenReport] = useState(false);
  const [terms, setTerms] = useState(null);
  const [captcha, setCaptcha] = useState(null);
  const [dataForm, setDataForm] = useState({
    data: {},
    reset: null,
  });
  const [location, setLocation] = useState({
    state: "",
    city: "",
  });
  const toastSuccessful = useToastSuccessful();
  const toastInfo = useToastInfo();

  const { error, data, loading } = useQuery(GET_STATE_BY_COUNTRY);

  const [checkDocumentIsReadyToDelivery, { data: verification, loading: loadingVerification }] = useLazyQuery(
    CHECK_DOCUMENT,
    {
      variables: {
        documentNumber: documentNumber,
      },
    },
  );

  const [sendData, { error: errorMutation, loading: loadingMutation }] = useMutation(
    MUTATION_CREATE_BIOMETRIC_REGISTRATION,
    {
      onCompleted: (e) => {
        setTimeout(() => {
          toastSuccessful(e.createApplicationForm.message);
        }, 500);
        setTimeout(() => {
          navigate(RoutesNames.home);
        }, 1000);
      },
      onError: (err) => console.error(err),
    },
  );
  useEffect(() => {
    checkDocumentIsReadyToDelivery();
  }, [documentNumber, checkDocumentIsReadyToDelivery]);

  useToastError(error || errorMutation);
  useToastLoading(loadingMutation);

  if (loading) return <LoadingScreen />;

  const states = data?.getStateByCountry.data;
  const onHandleSearch = (value, { resetForm }) => {
    setDocumentNumber(value.documentNumber);
    resetForm();
  };

  const onHandleSubmit = (values, { resetForm }) => {
    if (location.state === "" && location.city === "") {
      return toastInfo("Debe seleccionar un departamento y un municipio.");
    }
    if (values.rumv === "") {
      return toastInfo("Debe ingresar un RUMV.");
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: "submit" }).then((token) => {
        setCaptcha(token);
      });
    });
    if (
      (values.phoneNumber.length === 7 || values.phoneNumber.length === 10) &&
      (values.secondaryPhoneNumber.length === 7 || values.secondaryPhoneNumber.length === 10)
    ) {
      setModalVisible(true);
      setDataForm({
        data: values,
        reset: resetForm,
      });
    } else {
      return toastInfo("Los números de teléfono deben tener 7 o 10 números.");
    }
  };

  const onHandleAccept = (info) => {
    setModalVisible(false);
    sendData({
      variables: {
        firstName: info.data.name,
        lastName: info.data.lastName,
        phoneNumber: info.data.phoneNumber,
        secondaryPhoneNumber: info.data.secondaryPhoneNumber,
        optionalPhoneNumber: info.data.whatsAppPhoneNumber || null,
        stateId: parseInt(location.state),
        citiesId: location.city,
        termsAndConditionsAcceptedId: terms,
        email: info.data.email,
        step: "DELIVERY_DOCUMENT",
        neighborhood: info.data.neighborhood || undefined,
        rumvNumber: info.data.rumv,
        helpType: "FACE_TO_FACE",
        token: captcha,
      },
    });
    info.reset();
  };

  const OnMessage = () => {
    if (verification?.checkDocumentIsReadyToDelivery.message.split(" ").includes("no")) {
      return (
        <TextBold style={{ color: Variables.colorRed }}>
          {verification?.checkDocumentIsReadyToDelivery.message}
        </TextBold>
      );
    } else {
      return (
        <TextBold style={{ color: Variables.colorGreen }}>
          {verification?.checkDocumentIsReadyToDelivery.message}
        </TextBold>
      );
    }
  };

  return (
    <ContainerGlobal>
      <ContentForms>
        <TopText>
          Este portal pretende únicamente ayudar a gestionar los trámites, por lo que los tiempos, aceptación, negación,
          y gestión depende exclusivamente de las entidades encargadas.
        </TopText>
        <Header>
          <Title>Entrega de Documentos </Title>
          <Text>
            Este proceso lo podrás realizar directamente en la página de Migración Colombia
            <a style={{ overflowWrap: "break-word" }} href="https://www.migracioncolombia.gov.co">
              {" "}
              https://www.migracioncolombia.gov.co
            </a>
            . A continuación, podrás inscribirte para jornadas en tu municipio que pertenezca o no al área
            metropolitana.
          </Text>
        </Header>
        <ContainerBackAndInfo>
          <BackButton onClick={() => navigate(-1)}>
            <IconBack color="#000" width={20} height={20} />
            <TextBack>Atrás</TextBack>
          </BackButton>
          <ContainerReportProblem onClick={() => setOpenReport(true)}>
            <ImgIcon src="/home/Danger.png" />
            <div style={{ color: "#F9B233", fontWeight: " bold", textAlign: "center" }}>
              Preguntas, sugerencias, quejas, reclamos o felicitaciones del portal
            </div>
          </ContainerReportProblem>
        </ContainerBackAndInfo>
        <ContainerTransparent>
          <Info>
            <TextBold>
              *Las jornadas presenciales se realizarán siempre y cuando se inscriba suficientes personas.
              <div>
                *El equipo programador de la jornada revisará el número mínimo de personas requerido para realizarla
                según cada municipio.
              </div>
              *¡OJO se te informará telefónicamente la programación o información importante de las jornadas!.
            </TextBold>
            <TextInformative>
              Recuerda: para este trámite debiste haber realizado el registro BIOMÉTRICO.
            </TextInformative>
          </Info>
          <ContainerVerify>
            <ContainerUp>
              <ImgLeft src="/home/Documents.png" />
              <ContainerRight>
                <TextVerification>Verifica primero que tu documento se encuentre expedido e impreso.</TextVerification>
                <AppForm
                  initialValues={{
                    documentNumber: "",
                  }}
                  onSubmit={onHandleSearch}
                  validationSchema={validationDocumentDelivery}
                >
                  <ContainerFormVerify>
                    <ContainerInputs1>
                      <AppInput placeholder="Documento" name="documentNumber" />
                    </ContainerInputs1>
                    <AppSubmit
                      title="Buscar"
                      style={
                        width <= 820
                          ? { alignSelf: "center", width: "50%", height: 25, backgroundColor: "#F9B233" }
                          : { marginTop: 20, width: "20%", height: 25, backgroundColor: "#F9B233" }
                      }
                    />
                  </ContainerFormVerify>
                </AppForm>
              </ContainerRight>
            </ContainerUp>
            <TextBoldRed>
              *Si tu documento aparece como expedido e impreso en este buscador, podrás reclamarlo en la Calle 19 # 80 A
              40, Belén la Nubia, Medellín, Antioquia o podrás inscribirte en el formulario de abajo para las jornadas
              de entrega de documentos.
            </TextBoldRed>
            <div style={{ height: "100%" }}>
              {loadingVerification ? <AnimationLoading /> : documentNumber.length > 0 && OnMessage()}
            </div>
          </ContainerVerify>
          {verification?.checkDocumentIsReadyToDelivery.data && (
            <>
              <Info>
                <HeaderForm>
                  Quiero inscribirme en una jornada presencial para el proceso de ENTREGA DE DOCUMENTO
                </HeaderForm>
              </Info>
              <DataForm
                handleSubmit={onHandleSubmit}
                dataState={states || []}
                setLocation={setLocation}
                validationSchema={validationPPT}
                color="#11104B"
                rumv={true}
              ></DataForm>
            </>
          )}
        </ContainerTransparent>
        <ModalTermsConditions
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          press={() => onHandleAccept(dataForm)}
          setTerms={setTerms}
          idTermsAndConditions={TERMS_HABEAS_DATA}
        />
        <ModalReportProblem
          src={"/home/DangerBig.png"}
          setModalVisible={setOpenReport}
          modalVisible={openReport}
        ></ModalReportProblem>
      </ContentForms>
    </ContainerGlobal>
  );
}
